var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-card',{staticStyle:{"transition":"none"}},[_c('v-card-title',[_c('div',[_c('span',[_vm._v(_vm._s(_vm.popover))])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }